import { Injectable } from '@angular/core';

import { WorkflowMessage } from 'src/app/services/ai/ai.service';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  chatVisible = false;
  chatOpen = false;
  messages: WorkflowMessage[] = [];
  private context: string = '';

  constructor(
  ) {
  }

  setContext(context: string) {
    this.context = context;
  }

  getContext() {
    return this.context;
  }

  showChat() {
    this.chatVisible = true;
  }

  hideChat() {
    this.chatVisible = false;
  }

  openChat() {
    this.chatOpen = true;
  }

  closeChat() {
    this.chatOpen = false;
  }

  addMessage(message: WorkflowMessage) {
    this.messages.push(message);
  }

  clearMessages() {
    this.messages = [];
  }
}
